export enum EAppointmentFilterType {
  UPCOMING = 'upcoming',
  PAST = 'past',
}

export enum EOrderFilterType {
  UPCOMING = 'new',
  PAST = 'previous',
}
